export default __webpack_public_path__ + "static/media/challenge-end.cd0638c3.wav";